import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { VictoryIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export const PetitionStatusHeaderContainer: React.FC = () => {
	const {
		data: {
			petition: { isVerifiedVictory },
		},
	} = usePetitionDetailsPageData();
	return (
		<div className="block md:hidden">
			<div className="rounded-medium bg-gradient-background-dark-1 p-2">
				<div className="text-typography-inverse-strong flex flex-row justify-center gap-1">
					<VictoryIcon className="mt-0.5 flex h-8! items-center" />
					<Text as="h3" variant="heading" size="small">
						{isVerifiedVictory ? (
							<Translate value="fe.pages.petition_show.status.confirmed_victory" />
						) : (
							<Translate value="fe.pages.petition_show.status.victory" />
						)}
					</Text>
				</div>
			</div>
		</div>
	);
};
